<template>
  <div class="modulardate">
    <div
      data-grid
      class="modulardate__wrapper grid--va-center"
    >
      <label
        v-bind="{ for: id }"
        class="modulardate__label me-4 cursor-pointer"
      >
        {{ label }}
      </label>

      <div class="modulardate__content">
        <input
          type="date"
          v-bind="{
            id,
            name
          }"
          class="modulardate__field h-100 px-3"
          @input="handleDate"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModularDate',

  props: {
    id: {
      type: String,
      default: () => ''
    },

    name: {
      type: String,
      default: () => ''
    },

    label: {
      type: String,
      default: () => ''
    }
  },

  emits: ['input', 'update:modelValue'],

  methods: {
    exposeDate (date) {
      this.$emit('input', date)
      this.$emit('update:modelValue', date)
    },

    handleDate (event) {
      const { value } = event.target

      const date = new Date(`${value}T00:00:00.000`)

      this.exposeDate(date)
    }
  }
})
</script>

<style lang="scss" scoped>
  .modulardate {
    --height: 40px;
    --borderColor: #00D2FF;
    --labelColor: rgb(var(--gray1));
    --fieldColor: rgb(var(--gray16));

    &__label {
      color: var(--labelColor);
      font: 400 1.4rem / 1.8rem "Nunito", sans-serif;
    }

    &__content {
      width: 154px;
      height: var(--height);
    }

    &__field {
      color: var(--fieldColor);
      font: 400 1.6rem "Nunito", sans-serif;

      border: solid 1px var(--borderColor);
      border-radius: calc(var(--height) / 2);

      &[type="date"]::-webkit-inner-spin-button,
      &[type="date"]::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }
    }
  }
</style>
